const valueExistsInArray = (value, array) => array.some((item) => item.value === value);
export const selectValueRules = (stateValue, propsValue, optionsLabel, values) => {
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        return optionsLabel ? '' : undefined;
    }
    if ((propsValue === '' && optionsLabel) ||
        (propsValue && valueExistsInArray(propsValue, values))) {
        return `${propsValue}`;
    }
    if (stateValue && valueExistsInArray(stateValue, values)) {
        return `${stateValue}`;
    }
    if (!optionsLabel) {
        return values[0].value;
    }
    return '';
};
